import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import * as Models from '../../models/utils/country-language.interfaces';
import { CookieHelperService } from '../../services/utils';
import { ApplicationConfig } from '../config/config';
import { UrlUtil } from '../url/urlUtil';
@Injectable({
  providedIn: 'root'
})
export class CountryLanguageExtendedHelper {
  public urlToRedirect = '';
  public prefCookie = '';
  public countryLanguage!: BehaviorSubject<string>;
  public countryLanguageObservables!: Observable<string>;
  public countryLanguageList!: Models.CountryLanguages[];
  public translatedText!: Models.TranslatedText;
  public regionList!: Models.RegionList[];
  public redirectionList!: Models.RedirectionUrl[];
  public languageList!: Models.CountryLanguages[];
  public reqdLanguage!: Models.LanguageDetails[];
  languageCode = '';
  cookieHelper = inject(CookieHelperService);
  appconfig = inject(ApplicationConfig);
  urlUtil = inject(UrlUtil);
  defaultCountry = '';
  constructor() {
    this.defaultCountry = this.appconfig.get('APP_DEFAULT_COUNTRY');
    const pref = this.cookieHelper.getCookieValue('prefUI');
    if (pref && pref !== '') {
      this.prefCookie = pref;
    }
  }

  getPreferredLanguages(): Observable<string> {
    if (!this.countryLanguageObservables) {
      if (!this.countryLanguage) {
        this.countryLanguage = new BehaviorSubject<string>(
          this.prefCookie ? this.prefCookie : ''
        );
      }
      this.countryLanguageObservables = this.countryLanguage.asObservable();
    }
    return this.countryLanguageObservables;
  }

  setPreferredLanguages(prefvalue: string): void {
    this.prefCookie = prefvalue;
    if (this.countryLanguage) {
      this.countryLanguage.next(prefvalue);
    }
  }

  setPrefCookie(prefvalue: string): void {
    this.cookieHelper.setCookies('prefUI', prefvalue);
  }

  setShowConfirmationModal(shouldShow: boolean): void {
    if (shouldShow) {
      this.cookieHelper.setCookies('prefConf', 'Y');
    } else {
      this.cookieHelper.setCookies('prefConf', 'N');
    }
  }

  shouldShowConfirmationModal(): boolean {
    const str = this.cookieHelper.getCookieValue('prefConf');
    if (str && str !== '') {
      return this.getResValue(str);
    }
    return false;
  }

  getResValue(str: string): boolean {
    if (str === 'Y') {
      return true;
    } else {
      return false;
    }
  }

  getCountryForCountryCode(
    countryCode: string
  ): Models.CountryLanguages | null {
    countryCode = countryCode.toLowerCase();
    const languageList = this.countryLanguageList.filter(function (obj) {
      return obj.isoCode.toLowerCase().indexOf(countryCode) !== -1;
    });
    if (languageList.length > 0) {
      return languageList[0];
    }
    return null;
  }

  getLangaugeForLanguageCode(
    countryCode: string,
    languageCode: string
  ): Models.LanguageDetails | undefined {
    countryCode = countryCode.toLowerCase();
    languageCode = languageCode.toLowerCase();
    if (this.countryLanguageList) {
      const country = this.getCountryForCountryCode(countryCode);
      if (country) {
        const language = country.languageDtls.filter((item) => {
          return item.languageCode === languageCode;
        });
        return this.getLanguage(language);
      }
    }
    return undefined;
  }

  getLanguage(
    language: Models.LanguageDetails[]
  ): Models.LanguageDetails | undefined {
    if (language && language.length > 0) {
      return language[0];
    }
    return undefined;
  }

  checkLangListForActionUrl(): string {
    const shouldUseFullUrl = this.shouldUseFullUrl();
    return shouldUseFullUrl
      ? `${this.reqdLanguage[0].url}/${this.languageList[0].urlcc}/${this.reqdLanguage[0].languageCode}`
      : this.reqdLanguage[0].url;
  }

  private shouldUseFullUrl(): boolean {
    return Boolean(
      this.languageList &&
        this.languageList[0].urlcc &&
        this.languageList[0].urlcc !== '' &&
        this.defaultCountry.toLocaleLowerCase() !==
          this.languageList[0].urlcc.toLocaleLowerCase()
    );
  }
}
